import { Table, Text } from "melco-ui"
import { useGetAllProductsList } from "../../hooks/product/useGetAllProductsList"
import { useAddRemoveThreadProduct } from "../../hooks/threads/useAddRemoveThreadProduct"
import { useTranslation } from "react-i18next"
import { useMemo } from "react"

export type ThreadProductListProps = {}
export const ThreadProductList: React.FC<ThreadProductListProps> = () => {
    const {
        data,

        onTableConfigChange
    } = useGetAllProductsList("threads");

    const { t } = useTranslation();
    const { products, addThreadProducts, removeThreadProducts } = useAddRemoveThreadProduct();
    //  const { rowSelection, selectedRowKeys, setSelectedRowKeys, onRow } = useTableSelection<any>(() => { });

    //  derive selected keys from Formik
    const selectedRowKeys = useMemo(
        () => (products ?? []).map((p: any) => p.product_code),
        [products]
    );

    const columns = [
        {
            "title": t('managethreads.tabs.products.table.columns.name'),
            "key": "name",
            "dataIndex": "name"
        },

    ];

    //  controlled row selection
    const rowSelection = {
        selectedRowKeys,

        onChange: (newSelectedKeys: React.Key[]) => {
            const currentKeys = selectedRowKeys;

            //  items to add
            const toAdd = (data ?? []).filter(
                (d: any) =>
                    newSelectedKeys.includes(d.code) &&
                    !currentKeys.includes(d.code)
            );

            //  items to remove
            const toRemove = currentKeys.filter(
                (code: any) => !newSelectedKeys.includes(code)
            );

            if (toAdd.length) {
                addThreadProducts(toAdd);
            }

            if (toRemove.length) {
                removeThreadProducts(
                    toRemove.map((code: any) => ({
                        product_code: code
                    }))
                );
            }
        }
    };
    // selectedRowKeys: array of selected IDs (Key[])
    const selectedCount = selectedRowKeys.length;

    return (
        <>
            {selectedCount > 0 && (
                <div style={{ marginBottom: 1, textAlign: "right" }}>
                    <Text >{selectedCount} {t("managethreads.tabs.products.selected_products")}</Text>
                </div>
            )}
            <Table
                dataSource={data}
                columns={columns}
                rowSelection={rowSelection}
                rowKey="code" //  IMPORTANT
                onChange={onTableConfigChange}
            />
        </>
    )
}